import { Icon as IC } from "@iconify/react";

interface IconProps {
    icon: string;
    className?: string;
    width?: string | number;
    rotate?: 0 | 90 | 180 | 270;
    hFlip?: boolean;
    vFlip?: boolean;
}

const Icon = ({ icon, className, width, rotate, hFlip, vFlip }: IconProps) => {
    return (
        <IC
            width={width}
            rotate={rotate}
            hFlip={hFlip}
            icon={icon}
            className={className}
            vFlip={vFlip}
        />
    );
};

export default Icon;
